import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import InputValidator from '../common/InputValidator.jsx';
import validatedComponent from '../common/ValidatedComponent.jsx';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './redux/actions.forgotPw';

class FogotPasswordConsume extends React.Component {
  constructor() {
    super();

    this.state = {
      password: '',
      confirmPassword: ''
    };
    this.validatePasswords = this.validatePasswords.bind(this);
  }

  componentDidMount() {
    if (!this.props.params.token) {
      this.context.router.replace('/forgot');
    }
  }

  validatePasswords() {
    const {password, confirmPassword} = this.state;
    if (password !== confirmPassword) {
      return 'Both passwords must be equal';
    }
  }

  onResetClick(e) {
    e.preventDefault();

    if (this.context.isComponentValid()) {
      this.props.resetForgotPw(this.props.params.token, this.state.password);
    }
  }

  render() {
    const {password, confirmPassword} = this.state;
    const {isReset} = this.props;
    return (
      <div className="ba-reset-password panel">
        <div className="row">
          <div className="large-12 end columns">
            <h2>Reset password</h2>
          </div>
        </div>
        {!isReset ?
          <form noValidate>
            <div className="row">
              <div className="large-12 end columns">
                <InputValidator fieldName="New Password"
                                shouldValidateOnBlur={true}
                                customValidation={() => {
                                  return this.validatePasswords();
                                }}>
                  <input type="password"
                         required
                         value={password}
                         placeholder="enter new password"
                         onChange={e => this.setState({password: e.target.value})}/>
                </InputValidator>
              </div>
            </div>
            <div className="row">
              <div className="large-12 end columns profile-section-fieldvalue-credentials">
                <InputValidator fieldName="Confirm Password"
                                required
                                shouldValidateOnBlur={true}
                                customValidation={() => {
                                  return this.validatePasswords();
                                }}>
                  <input type="password"
                         required
                         value={confirmPassword}
                         placeholder="retype new password"
                         onChange={e => this.setState({confirmPassword: e.target.value})}/>
                </InputValidator>
              </div>
            </div>
            <div className="row">
              <div className="large-12 columns">
                <button type="button"
                        onClick={this.onResetClick.bind(this)}>
                  Reset Password
                </button>
              </div>
            </div>
          </form>
          :
          <div className="row">
            <div className="large-12 end columns">
              <p>Your new password has been successfully set. You can now <Link to="login">log in</Link>.</p>
            </div>
          </div>
        }
      </div>);
  }
}

FogotPasswordConsume.displayName = 'FogotPasswordConsume';

FogotPasswordConsume.propTypes = {
  params: PropTypes.shape({
    token: PropTypes.string.isRequired
  })
};

FogotPasswordConsume.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {...state.forgotPw};
}

export default connect(mapStateToProps, mapDispatchToProps)(validatedComponent(FogotPasswordConsume));



// WEBPACK FOOTER //
// ./shared/auth/ForgotPasswordConsume.jsx